import { IAppointmentHoverModel, IAppointmentModel } from "@models";

export interface IHoveredAppointmentModel {
    appointment: IAppointmentModel;
    hoverInfo: IAppointmentHoverModel;
    appointmentBlock: HTMLDivElement;
    // Right-clicking an appointment pins the panel open so it behaves like the context menu it replaced
    isPinned: boolean;
}

export class HoveredAppointmentModel implements IHoveredAppointmentModel {
    constructor(hoverInfo: IAppointmentHoverModel, appointmentBlock: HTMLDivElement, isPinned: boolean = false) {
        this.hoverInfo = hoverInfo;
        this.appointment = hoverInfo?.appointment;
        this.appointmentBlock = appointmentBlock;
        this.isPinned = isPinned;
    }

    appointment: IAppointmentModel;
    hoverInfo: IAppointmentHoverModel;
    appointmentBlock: HTMLDivElement;
    isPinned: boolean;
}
